<template>
  <resource-collection :search="false">
    <mark-all-as-read-button class="m-1" slot="after-actions" @done="handleDone">Tout marquer comme lu</mark-all-as-read-button>
    <template slot-scope="{item}">
      <component :is="getType(item)" :notification="item"/>
    </template>
  </resource-collection>
</template>

<script>
/* globals moment */

import ResourceCollection from '../resources/ResourceCollection.vue';
import collection from '../../mixins/collection';
import notificationsRegistered from '../../mixins/notificationsRegistered';
import MarkAllAsReadButton from '../notifications/NotificationMarkAllAsReadButton.vue';

export default {
  mixins: [collection, notificationsRegistered],

  components: { ResourceCollection, MarkAllAsReadButton },

  mounted() {
    Event.listen('notificationUpdated', notification =>
      this.update(notification),
    );
    Event.listen('notificationCreated', notification =>
      this.prepend(notification),
    );
    Event.listen('notificationDeleted', notification =>
      this.remove(notification),
    );
  },

  methods: {
    getType(notification) {
      return `Notification${notification.type.split('\\').pop()}`;
    },

    handleDone() {
      this.items.filter(item => item.read_at === null).forEach((item) => {
        item.read_at = moment().format();
      });
    },
  },
};
</script>